var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 256,
    viewBox: "0 0 249 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_3_752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4329 256.805C106.981 200.811 137.488 71.2797 -0.869566 1.10768",
    stroke: "#FBAAAB",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.554 256.805C223.66 191.433 142.123 84.6852 -0.868803 180.675",
    stroke: "#FBAAAB",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 249,
    height: 255.64,
    fill: "white",
    transform: "translate(0 0.186523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.4017e6932e3f75c7c13b2c100f352f88.svg";
export { ForwardRef as ReactComponent };